/** Paramètres globaux d’encaissement (pas l’IBAN). */
export type RecurringAuto = "off" | "send" | "due";

export type PaymentKind = "transfer" | "card" | "sepa" | "paypal" | "stripe" | "check" | "cash";

export const PAYMENT_KINDS: { id: PaymentKind; label: string }[] = [
  { id: "transfer", label: "Virement bancaire" },
  { id: "card", label: "Carte bancaire" },
  { id: "sepa", label: "Prélèvement SEPA" },
  { id: "paypal", label: "PayPal" },
  { id: "stripe", label: "Stripe" },
  { id: "check", label: "Chèque" },
  { id: "cash", label: "Espèces" },
];

export function snapQuarterHour(raw: string, fallback: string): string {
  const m = /^(\d{1,2}):(\d{2})/.exec(raw || "") || /^(\d{1,2}):(\d{2})/.exec(fallback);
  if (!m) return fallback;
  let h = Math.min(23, Math.max(0, Number(m[1])));
  let i = Math.min(59, Math.max(0, Number(m[2])));
  i = Math.round(i / 15) * 15;
  if (i >= 60) {
    i = 0;
    h = (h + 1) % 24;
  }
  return `${String(h).padStart(2, "0")}:${String(i).padStart(2, "0")}`;
}

export type CompanyPayments = {
  auto_bill_invoices: boolean;
  auto_bill_recurring: RecurringAuto;
  auto_bill_at: string;
  gc_charge_at: string;
  default_payment_term_id: number | null;
  default_payment_kind: PaymentKind;
  quote_valid_days: number;
  email_payment_manual: boolean;
  email_payment_online: boolean;
  email_payment_marked: boolean;
  late_penalty_label: string;
  early_discount_bp: number;
};

export type PaymentTerm = {
  id: number;
  label: string;
  days: number;
  end_of_month: boolean | number;
  is_default: boolean | number;
};

function asBool(v: unknown, fallback: boolean): boolean {
  if (v == null) return fallback;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (v === "0" || v === "false") return false;
  return Boolean(v);
}

export function paymentsFromCompany(row: Partial<CompanyPayments> & {
  auto_charge_on_due?: boolean | number | null;
  email_on_payment?: boolean | number | null;
} | null | undefined): CompanyPayments {
  const rec = row?.auto_bill_recurring;
  const days = Number(row?.quote_valid_days ?? 30);
  const mail = row?.email_on_payment;
  return {
    auto_bill_invoices: asBool(row?.auto_bill_invoices ?? row?.auto_charge_on_due, false),
    auto_bill_recurring: rec === "send" || rec === "due" ? "send" : "off",
    auto_bill_at: snapQuarterHour(String((row as { auto_bill_at?: string } | null)?.auto_bill_at || ""), "06:15"),
    gc_charge_at: snapQuarterHour(String((row as { gc_charge_at?: string } | null)?.gc_charge_at || ""), "06:30"),
    default_payment_term_id: row?.default_payment_term_id ? Number(row.default_payment_term_id) : null,
    default_payment_kind: PAYMENT_KINDS.some((k) => k.id === row?.default_payment_kind)
      ? (row?.default_payment_kind as PaymentKind)
      : "transfer",
    quote_valid_days: days >= 1 && days <= 365 ? days : 30,
    email_payment_manual: asBool(row?.email_payment_manual ?? mail, true),
    email_payment_online: asBool(row?.email_payment_online ?? mail, true),
    email_payment_marked: asBool(row?.email_payment_marked ?? mail, true),
    late_penalty_label: (row as { late_penalty_label?: string | null } | null)?.late_penalty_label || "trois fois le taux d’intérêt légal",
    early_discount_bp: Math.max(0, Math.min(10000, Number((row as { early_discount_bp?: number | null } | null)?.early_discount_bp ?? 0) || 0)),
  };
}
